import { omit } from 'lodash';
import { AnyActorRef, AnyState } from 'xstate';

const sensitiveData = [
  'password',
  'paymentToken',
  'utilityPassword',
  'utilityConnectToken',
] as const;

type SensitiveData = (typeof sensitiveData)[number];
export const removeSensitiveData = <T extends object>(
  context: T,
): Omit<Partial<T>, SensitiveData> => omit(context, sensitiveData);

export const parseState = <T extends AnyState>(currentState: T) => {
  const stateArray = currentState.toStrings();
  return {
    parentState: stateArray[0],
    childState: stateArray[1] ? stateArray[1].split('.')[1] : undefined,
    grandChildState: stateArray[2] ? stateArray[2].split('.')[2] : undefined,
    dotNotation: stateArray[stateArray.length - 1],
  };
};

// @ts-expect-error - prevents the useActor hook from errors when a children.someMachine is undefined
export const emptyActor = {
  getSnapshot: () => undefined,
  subscribe: () => ({
    unsubscribe: () => {},
  }),
  send: () => {},
  id: 'emptyActor',
} as AnyActorRef;
